import { render, staticRenderFns } from "./ModalsRegisterUser.vue?vue&type=template&id=6bec222e&scoped=true&"
import script from "./ModalsRegisterUser.vue?vue&type=script&lang=ts&"
export * from "./ModalsRegisterUser.vue?vue&type=script&lang=ts&"
import style0 from "./ModalsRegisterUser.vue?vue&type=style&index=0&id=6bec222e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec222e",
  null
  
)

export default component.exports